export const menuItems = [
    {
        label: "Home",
        icon: "mdi mdi-home",
        link: "/"
    },
    {
        label: "Services",
        icon: "mdi mdi-cart",
        link: "/products"
    },
    {
        label: "Service Providers",
        icon: "mdi mdi-account-edit",
        link: "/shops"
    },
    {
        label: "Contact Us",
        icon: "mdi mdi-account-edit",
        link: "/contact"
    },
   
];